export default {
    colors: [
      // https://trello.com/c/383hc2zf/430-%C4%91%E1%BB%95i-list-m%C3%A0u-d%C3%B9ng-cho-c%C3%A1c-chart
      'rgba(78, 170, 241, 1)', // blue
      'rgba(255, 175, 9, 1)', // yel
      'rgba(40, 194, 112, 1)', // green
      'rgba(253, 93, 161, 1)', // pink
      'rgba(118, 105, 191, 1)', // purple
      'rgba(18, 67, 69, 1)', // dark teal
      'rgba(156, 162, 174, 1)', // grey
      'rgba(79, 151, 241, 1)', // blue 2
      'rgba(255, 199, 0, 1)', // yel 2
      'rgba(40, 194, 129, 1)', // green 2
      'rgba(253, 93, 142, 1)', // pink 2
      'rgba(127, 105, 191, 1)', // purple 2
      'rgba(37, 43, 53, 1)', // near black
      'rgba(156, 165, 174, 1)', // grey 2
      'rgba(77, 183, 240, 1)', // blue 3
      'rgba(255, 156, 16, 1)', // orange
      'rgba(40, 194, 99, 1)', // green 3
      'rgba(253, 92, 173, 1)', // pink 3
      'rgba(110, 105, 191, 1)', // purple 3
      'rgba(59, 30, 54, 1)', // dark plum
      'rgba(162, 155, 175, 1)', // grey purple
      'rgba(116, 76, 242, 1)', // purple 4
      'rgba(154, 240, 37, 1)', // neon green
      'rgba(43, 158, 195, 1)', // sky
      'rgba(253, 152, 89, 1)', // light orange
      'rgba(182, 105, 191, 1)', // weird purple
      'rgba(55, 52, 33, 1)', // some brown-green
      'rgba(155, 170, 174, 1)', // grey blue
      'rgba(74, 225, 239, 1)', // fresh blue
      'rgba(255, 100, 28, 1)', // fresh orange
    ],
    defaultWords: [
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Interactive',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Conversation',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Engagement',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Connection',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Community',
      'Dialogue',
      'Dialogue',
      'Dialogue',
      'Dialogue',
      'Dialogue',
      'Dialogue',
      'Dialogue',
      'Dialogue',
      'Brainstorming',
      'Brainstorming',
      'Brainstorming',
      'Brainstorming',
      'Brainstorming',
      'Brainstorming',
      'Learning',
      'Learning',
      'Learning',
      'Learning',
      'Learning',
      'Learning',
      'School',
      'School',
      'School',
      'School',
      'School',
      'School',
      'Class',
      'Class',
      'Class',
      'Students',
      'Students',
      'Students',
      'Remote work',
      'Remote work',
      'Lessons',
      'Lessons',
      'Team meetings',
      'Team meetings',
      'Sharing',
      'Sharing',
      'Training',
      'Training',
      'Attention',
      'Attention',
      'Ideas',
      'Ideas',
      'Virtual',
      'Teacher',
      'Inspiration',
      'Convenient',
      'Online',
    ]
  }
  